import React from 'react';
import ReduxToastr from 'react-redux-toastr'
import styled from 'styled-components';
import colors from '../../../lib/Colors';

const toastrConfig = {
  closeOnToastrClick: true,
  timeOut: 10000,
  transitionIn: 'fadeIn',
  transitionOut: 'fadeOut',
};

const StyledToaster = styled.div`  
  & .rrt-title {
    font-weight: 400 !important;
  }
  & .toastr.animated.rrt-error {
    background: ${colors.red};   
    box-shadow: 2px 2px 10px rgba(0,0,0,.4);
    opacity: 1;
  }; 
`;

const ToastrWrapper = () => {
  return(
    <StyledToaster>
      <ReduxToastr {...toastrConfig}/>
    </StyledToaster>
  )
};

export default ToastrWrapper;
